export type LabelColor = 'blue' | 'teal' | 'green' | 'orange' | 'purple' | 'red' | 'grey' | 'yellow';

/**
 * Maps issue status to PatternFly Label color.
 */
export const getStatusLabelColor = (status: string | undefined): LabelColor => {
  if (!status) return 'grey';
  const statusLower = status.toLowerCase();

  if (statusLower.includes('done') || statusLower.includes('closed') || statusLower.includes('resolved')) {
    return 'green';
  }
  if (statusLower.includes('progress') || statusLower.includes('review')) {
    return 'blue';
  }
  if (statusLower.includes('blocked') || statusLower.includes('impediment')) {
    return 'red';
  }
  if (statusLower.includes('todo') || statusLower.includes('open') || statusLower.includes('backlog')) {
    return 'teal';
  }
  if (statusLower.includes('test')) {
    return 'purple';
  }
  return 'grey';
};

const LABEL_COLORS: LabelColor[] = ['blue', 'teal', 'green', 'orange', 'purple', 'red', 'yellow'];

/**
 * Returns a deterministic PatternFly Label color for any string value.
 * Same input always produces the same color.
 */
export const getLabelColor = (value: string): LabelColor => {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = ((hash << 5) - hash + value.charCodeAt(i)) | 0;
  }
  return LABEL_COLORS[Math.abs(hash) % LABEL_COLORS.length];
};
